/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";
import { formatCurrency } from "utils";
import { PRODUCT_IDS } from "utils/constants";
import { useQuery } from "@apollo/react-hooks";
import Loading from "components/common/SimpleLoading";
import { Link, useHistory } from "react-router-dom";
import { GET_CREDIT_BOOST_TRANSACTIONS } from "../Boost/mutations";
import { ProductCardDefault } from "./ProductCardDefault";
import { PRODUCT_CARD_DEFAULT_CONFIG } from "./const";
import { getButtonClassName } from "./utils";
import { NoAccounts } from "../Boost/components";

const NUM_TRANS_TO_DISPLAY = 6;

export const BoostSnapshotTransactionsTable = ({ data = [] }) => {
  return (
    <div className="overflow-x-auto relative rounded-md">
      <table className="w-full text-sm text-left text-gray-500" style={{ color: "#111928" }}>
        <thead className="text-xs uppercase bg-neutral-50" style={{ color: "#6B7280" }}>
          <tr>
            <th scope="col" className="py-3 px-6">
              Description
            </th>
            <th scope="col" className="py-3 px-6">
              Amount
            </th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, idx) => (
            // eslint-disable-next-line react/no-array-index-key
            <tr key={`boost-table-${idx}`} className="bg-white border-b">
              <td className="py-4 px-6">
                {item.description}
              </td>
              <td className="py-4 px-6 font-semibold">
                {item.amount}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export const CreditBoostSnapshot = ({ belowBreakpoint, redirectUrl }) => {
  const queryOptions = {
    variables: {
      order: "DESC",
      limit: 10,
    },
  };
  const creditBoostConfig = PRODUCT_CARD_DEFAULT_CONFIG[PRODUCT_IDS.CREDIT_BOOST];
  const { loading, error, data } = useQuery(GET_CREDIT_BOOST_TRANSACTIONS, queryOptions);
  const boostTransactions = data?.getCreditBoostTransactions?.transactions || [];
  const boostTableData = boostTransactions
    .sort((a, b) => b.posteddate - a.posteddate)
    .slice(0, NUM_TRANS_TO_DISPLAY)
    .map((trans) => ({
      description: trans.normalizedpayee || trans.description,
      // posted_date: convertToShortDate(new Date(trans.posted_date)),
      amount: formatCurrency(trans.amount),
    }));
  const history = useHistory();

  if (loading) {
    return <Loading />;
  }
  if (error) {
    // eslint-disable-next-line react/jsx-props-no-spreading
    return <ProductCardDefault {...creditBoostConfig} />;
  }
  return (
    <div
      className="p-5 md:p-10 flex flex-col items-start flex-1 border rounded-md overflow-hidden border-neutral-300 hover:border-neutral-700 bg-white relative"
      onClick={() => belowBreakpoint && history.push(redirectUrl)}
    >
      <div className="text-2xl font-bold">Boost</div>
      <div className="mt-4">Recent bills</div>
      <div className="mt-4 w-full mdl:pb-16">
        {
          boostTableData?.length ?
            <BoostSnapshotTransactionsTable data={boostTableData} /> :
            <NoAccounts className="pt-10" />
        }
      </div>
      {!belowBreakpoint && <div className="mb-10 absolute bottom-0 left-0 w-full">
        <Link
          to={creditBoostConfig.redirectUrl}
          className={getButtonClassName("mx-auto")}
          style={{ maxWidth: 202 }}
        >
          Manage Boost
        </Link>
      </div>}
    </div>
  );
};
